module.exports = __webpack_public_path__ + "static/bits-49a29f5d9567bc37fb3e2fc5c959f1ca.png";